/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./Zh.css";
import { Link, Redirect } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";
import { DONOR_AUTH, ORG_AUTH, PLATFORM } from "../../config";
import { checkLoginStatus } from "../../assets/helper";
import PlugZh from "../PlugZh/PlugZh";

class Zh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    // Platform conditional rendering. On Plug the homepage is the marketing
    // site, not the marketplace — the marketplace is where its sign-up and
    // "Browse nonprofits" buttons lead, at /webapp (CP-318).
    //
    // Except for a session that is already signed in. This path used to render
    // the marketplace, which opens the workspace an org or donor belongs to;
    // handing them marketing copy and a "Log in" button instead loses them the
    // way back to their own dashboard. The site keeps its own paths (/PlugEn
    // and friends), so it is still readable while signed in.
    if (PLATFORM === "plug") {
      if (checkLoginStatus(ORG_AUTH) || checkLoginStatus(DONOR_AUTH)) {
        return <Redirect to="/webapp" />;
      }
      return <PlugZh {...this.props} />;
    }

    // Existing CheckPlus implementation
    return (
      <div className="Zh-view">
        <Helmet>
          <title>CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="Zh-first">
          <div className="Zh-firstContainer">
            <div className="Zh-first-content">
              <div className="Zh-first-picture" />
              <div className="Zh-first-text">
                <div className="Zh-heading">機構自動化</div>

                <div className="Zh-noteTxt">
                  屬香港《稅務條例》第88條的免稅非牟利機構才可使用 CheckPlus for
                  Nonprofits。
                </div>

                <Link to="/EnVideo">
                  <div className="Zh-supportOrgNextContainer">
                    <div className="Zh-supportOrgNextText">觀看影片</div>
                    <div className="Zh-supportOrgNextArrow" />
                  </div>
                </Link>
              </div>

              <div className="Zh-awardsOuterContainer">
                <div className="Zh-trophyContainer">
                  <div className="Zh-trophyIcn" />
                  <div className="Zh-trophyTxt">獎項</div>
                </div>

                <div className="Zh-awards" />
              </div>

              <div className="Zh-awardsOuterContainer">
                <div className="Zh-trophyContainer">
                  <div className="Zh-pressIcn" />
                  <div className="Zh-pressTxt">媒體報導</div>
                </div>
                <div className="Zh-newspaperContainer">
                  <div className="Zh-hkej" />
                  <div className="Zh-ejtech" />
                  <div className="Zh-hktkww" />
                  <div className="Zh-wenweipo" />
                </div>
                <div className="Zh-newspaperContainer">
                  <div className="Zh-oncc" />
                  <div className="Zh-techapple" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Zh-organizationPage">
          <div className="Zh-nonprofitContainer">
            <div className="Zh-nonprofitCircle">
              <div className="Zh-nonprofitIcn" />
            </div>
            <div className="Zh-nonprofitTxt">非牟利機構</div>
          </div>
          <div className="Zh-orgText">多間非牟利機構已經使用 CheckPlus</div>
          <div className="Zh-organizations">
            <a
              href="https://cbnhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-cbnhk" />
            </a>

            <a
              href="https://peacemaker.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-peacemaker" />
            </a>

            <a
              href="https://bbhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-bbhk" />
            </a>

            <a
              href="https://lovefoundation.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-LF" />
            </a>

            <a
              href="https://cchchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-cchchk" />
            </a>

            <a
              href="https://charactercity.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-charactercity" />
            </a>

            <a
              href="https://sunriseministry.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-sunriseministry" />
            </a>

            <a
              href="https://sunrisechurch.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-sunrisechurch" />
            </a>

            <a
              href="https://gnci.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-gnci" />
            </a>

            <a
              href="https://networkj.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-networkj" />
            </a>

            <a
              href="https://emmhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-emmhk" />
            </a>

            <a
              href="https://gfy.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-gfy" />
            </a>

            <a
              href="https://echovalley.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-echovalley" />
            </a>

            <a
              href="https://godsglory.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-godsglory" />
            </a>

            <a
              href="https://nav2000hk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-nav2000hk" />
            </a>

            <a
              href="https://gcchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-gcchk" />
            </a>

            <a
              href="https://petrosbookroom.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-alo" />
            </a>

            <a
              href="https://elijahmission.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-elijahmission" />
            </a>

            <a
              href="https://4limb.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-direction" />
            </a>

            <a
              href="https://rcsahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-rcsahk" />
            </a>

            <a
              href="https://ebs.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-ebs" />
            </a>

            <a
              href="https://raphahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-raphahk" />
            </a>

            <a
              href="https://livinghopeworld.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-livinghope" />
            </a>

            <a
              href="https://footprintgallery.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-footprint" />
            </a>

            <a
              href="https://alayluya.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-alayluya" />
            </a>

            <a
              href="https://crownfinancial.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-crownhk" />
            </a>

            <a
              href="https://psyreligion.check.plus"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-capr" />
            </a>

            <a
              href="https://ecohk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-eco" />
            </a>

            <a
              href="https://senrights.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-senrights" />
            </a>

            <a
              href="https://nytec.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Zh-frame Zh-nytec" />
            </a>
          </div>
        </div>

        <div className="Zh-orgText">主要功能</div>

        <div className="Zh-mouseContainer">
          <div className="Zh-mouseIcn" />
          <div className="Zh-mouseTxt">向左或向右捲動</div>
        </div>

        <div className="Zh-third">
          <div className="Zh-third-space" />
          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext">
                <div className="Zh-third-firstIcnContainer">
                  <div className="Zh-second-firstIcn" />
                </div>

                <div className="Zh-third-brandText">建立捐款網頁</div>
              </div>

              <div className="Zh-third-description">
                透過 CheckPlus，系統會自動為閣下的機構準備一個捐款網頁。
              </div>
            </div>

            <div className="Zh-third-iphone" />
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext">
                <div className="Zh-fourth-secondIcnContainer">
                  <div className="Zh-second-secondIcn" />
                </div>
                <div className="Zh-third-brandText">多個捐款項目</div>
              </div>

              <div className="Zh-third-description">
                機構可以建立多個籌款項目，還可以輕鬆地為其項目設置籌款目標。
              </div>
            </div>

            <div className="Zh-fourth-iphone" />
          </div>
          <div className="Zh-transaction-type-container ">
            <div className="Zh-transaction-type-top">
              <div className="Zh-donation-payment-switch" />
            </div>
            <div className="Zh-transaction-type-text-container">
              <div className="Zh-donation-payment-icons" />
              <div className="Zh-transaction-type-text">設定付款或捐款類型</div>

              <div className="Zh-transaction-type-description">
                機構可以設定付款或捐款類型，以確保系統自動發出正確合規格的收據。
              </div>
            </div>
          </div>
          <div className="Zh-accept-networks-container">
            <div className="Zh-cardIcn-circle">
              <div className="Zh-cardIcn" />
            </div>
            <div className="Zh-cardTxt">接受多個付款方式</div>

            <div className="Zh-third-text-Container">
              <div className="Zh-networkList">
                <div className="Zh-paymentRow1">
                  <div className="Zh-visaIcon" />
                  <div className="Zh-mastercardIcon" />
                  <div className="Zh-amexIcon" />
                  <div className="Zh-unionpayIcon" />
                </div>
                <div className="Zh-paymentRow2">
                  <div className="Zh-applePay" />
                  <div className="Zh-googlePay" />
                  <div className="Zh-payme" />
                </div>
              </div>
            </div>
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext">
                <div className="Zh-sixth-fourthIcnContainer">
                  <div className="Zh-second-fourthIcn" />
                </div>

                <div className="Zh-third-brandText">支援每月定期捐款</div>
              </div>

              <div className="Zh-third-description">
                捐款者可以自行透過捐款網頁安排每月定期捐款，他們還可以自行更新的已安排捐款。(僅適用於已註冊帳戶的捐款者)
              </div>
            </div>

            <div className="Zh-frequency" />
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext-noDescription">
                <div className="Zh-fifth-fifthIcnContainer">
                  <div className="Zh-second-fifthIcn" />
                </div>

                <div className="Zh-third-brandText">捐款者户口</div>
              </div>
            </div>

            <div className="Zh-fifth-iphoneLeft" />
          </div>

          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext-noDescription">
                <div className="Zh-fifth-fifthIcnContainer2">
                  <div className="Zh-second-sixthIcn" />
                </div>

                <div className="Zh-third-brandText">收集捐款者資料</div>
              </div>
            </div>

            <div className="Zh-fifth-iphoneRight" />
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext">
                <div className="Zh-receipt-seventhIcnContainer">
                  <div className="Zh-second-seventhIcn" />
                </div>
                <div className="Zh-third-brandText">自動付款及捐款收據處理</div>
              </div>
              <div className="Zh-third-description">
                系統會即時自動處理捐款收據及發送至捐款者所提供的電郵地址。
              </div>
            </div>

            <div className="Zh-receiptSample" />
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-reports-features" />
            <div className="Zh-third-text-Container">
              <div className="Zh-iconWithtext">
                <div className="Zh-reports-eighthIcnContainer">
                  <div className="Zh-second-eighthIcn" />
                </div>

                <div className="Zh-third-brandText">自動準備報告</div>
              </div>

              <div className="Zh-third-description">
                機構可以隨時輸入開始和結束日期請求系統準備報告，系統會準備報告並將報告發送到您的電子郵件。
              </div>
            </div>
          </div>
          <div className="Zh-thirdContainer">
            <div className="Zh-banks">
              <div className="Zh-banksContainer">
                <div className="Zh-bankText">
                  支援所有香港金融管理局持牌銀行
                </div>

                <div className="Zh-bankList">
                  <a
                    href="https://www.hsbc.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-hsbc" />
                  </a>

                  <a
                    href="https://www.bochk.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-boc" />
                  </a>

                  <a
                    href="https://www.hangseng.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-hsb" />
                  </a>

                  <a
                    href="https://www.sc.com/hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-sc" />
                  </a>

                  <a
                    href="https://www.icbcasia.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-icbc" />
                  </a>

                  <a
                    href="https://www.citibank.com.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-citi" />
                  </a>

                  <a
                    href="https://www.dbs.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-dbs" />
                  </a>

                  <a
                    href="https://www.hkbea.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-bea" />
                  </a>
                </div>

                <div className="Zh-bankNextContainer">
                  <a
                    href="https://www.hkicl.com.hk/eng/information_centre/clearing_code_and_branch_code_list.php"
                    className="Zh-bankNextText"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    更多銀行
                  </a>
                  <div className="Zh-bankNextArrow" />
                </div>
              </div>
            </div>
          </div>
          <div className="Zh-third-space2" />
        </div>

        <div className="Zh-privacy">
          <div className="Zh-privacyContainer">
            <div className="Zh-privacyIcn" />
            <div className="Zh-privacyTxt">私隱</div>
            <div className="Zh-privacyDescription">
              你的數據應該是屬於你的。
            </div>
            <Link to="/ZhPrivacy">
              <div className="Zh-privacyBtn">
                <div className="Zh-privacyBtnTxt">了解更多</div>
                <div className="Zh-privacyNext" />
              </div>
            </Link>
          </div>
        </div>

        <div className="Zh-tenth">
          <div className="Zh-tenth_container">
            <div className="Zh-tenth-innerContainer">
              <div className="Zh-tenth-text1">
                我們為機構準備了一份資料概要
                PDF，以便您可以進一步了解有關我們的服務。
              </div>
              <div className="Zh-brochureBtn">
                <div className="Zh-brochureBtn-container">
                  <div className="Zh-brochureIcn" />
                  <a
                    href="https://drive.google.com/file/d/1O60Xz6mIkK7jmH5fZvwFlQ6_4v2Fj1YT/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-brochureTxt">下載資料概要 [PDF]</div>
                  </a>
                </div>
              </div>
              <br />
              <div className="Zh-tenth-text1">
                需要更多資料？我們可以跟您一對一見面！
              </div>
              <div className="Zh-meetBtn">
                <div className="Zh-brochureBtn-container">
                  <div className="Zh-meetIcn" />
                  <a
                    href="https://forms.gle/UJ4yasfAtMvqEBeHA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Zh-brochureTxt">安排會議</div>
                  </a>
                </div>
              </div>
              <br />
              <div className="Zh-tenth-text1">
                如果機構準備好了，請隨時註冊及建立屬於您機構的捐款網頁。
              </div>
              <div className="Zh-registerBtn">
                <div className="Zh-registerBtn-container">
                  <div className="Zh-registerIcn" />
                  <Link to="/OrgLogin">
                    <div className="Zh-registerTxt">立即登記</div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="Zh-tenth-iphone" />
          </div>
        </div>

        <div className="Zh-footer">
          <div className="Zh-footerNav">
            <Link to="/ZhTeam">
              <div className="Zh-footerNavItem">創辦人的故事</div>
            </Link>

            <Link to="/ZhFaq">
              <div className="Zh-footerNavItem">常見問題</div>
            </Link>

            <Link to="/ZhContact">
              <div className="Zh-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="Zh-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="Zh-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="Zh-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default Zh;
